// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-fotogalerie-provozovna-jsx": () => import("./../../../src/pages/fotogalerie/provozovna.jsx" /* webpackChunkName: "component---src-pages-fotogalerie-provozovna-jsx" */),
  "component---src-pages-fotogalerie-veze-jsx": () => import("./../../../src/pages/fotogalerie/veze.jsx" /* webpackChunkName: "component---src-pages-fotogalerie-veze-jsx" */),
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-mapa-provozovna-jsx": () => import("./../../../src/pages/mapa/provozovna.jsx" /* webpackChunkName: "component---src-pages-mapa-provozovna-jsx" */),
  "component---src-pages-mapa-vedeni-jsx": () => import("./../../../src/pages/mapa/vedeni.jsx" /* webpackChunkName: "component---src-pages-mapa-vedeni-jsx" */)
}

